export const getAppDisplayName = (rawName?: string | null): string => {
  if (rawName && rawName.trim().length > 0) {
    return rawName.trim();
  }
  return 'Webready';
};

export const getAppNamespace = (rawName?: string | null): string => {
  const base = getAppDisplayName(rawName).toLowerCase();
  const slug = base.replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  return slug || 'webready';
};

export const buildAppScopedKey = (rawName: string | null | undefined, suffix: string): string => {
  return `${getAppNamespace(rawName)}_${suffix}`;
};

